import { PrivateInvestorDocument, PrivateInvestorDocumentRedirectParams } from 'types/investor-documents';
import { apiSecureRequest } from '@utils/request';

export async function privateInvestorDocumentViewRedirect(params: PrivateInvestorDocumentRedirectParams): Promise<PrivateInvestorDocument> {
    const response = await apiSecureRequest.get(`/private-investor-documents/${params.documentType}/${params.documentId}/view`);
    return response.data;
}
